// File: /js/shared/extensions/socialCards-create.js
//
// Client-side management for the inline "Cartes sociales" section in
// upload mode. Two operations only:
//
//   - "+ Ajouter une carte" → clone the slot template, substitute the
//     next sequential index into form-field names, append to the list.
//   - "Supprimer cette carte" → remove the slot from the DOM.
//
// Block-level operations inside each card (text/image add, reorder,
// delete, media upload) are handled by the existing `blockEventBus`
// since each card's content_blocks section uses the standard
// `data-block-type="mixed"` markup. No new block-edit JS needed here.
//
// Edit mode uses different markup (each card is a real DB row with
// a scope-hash override) so this file is only relevant on upload pages.
// The listener is bound globally and silently no-ops on pages without
// the section.

const TEMPLATE_ID  = 'associated-social-card-slot-template';
const LIST_ATTR    = 'data-associated-social-cards-list';
const ADD_ATTR     = 'data-add-social-card';
const REMOVE_ATTR  = 'data-remove-social-card';
const PLACEHOLDER  = '__IDX__';

/**
 * Find the next sequential index for a new card slot. We don't reindex
 * existing slots when one is removed — PHP's nested-array parsing
 * handles sparse keys fine, and stable indices avoid invalidating any
 * partially-filled inputs in adjacent slots.
 */
function nextCardIndex(list) {
  let maxIndex = -1;
  list.querySelectorAll('.associated-card[data-card-slot-index]').forEach((card) => {
    const i = parseInt(card.dataset.cardSlotIndex, 10);
    if (Number.isFinite(i) && i > maxIndex) maxIndex = i;
  });
  return maxIndex + 1;
}

function addCardSlot(list, template) {
  const index = nextCardIndex(list);
  const html  = template.innerHTML.replaceAll(PLACEHOLDER, String(index));

  // Use a temporary container to parse the HTML into a real Element,
  // then move the first element child onto the list. This preserves any
  // <select> default selections and avoids the documentFragment
  // gotchas with template.content.
  const wrapper = document.createElement('div');
  wrapper.innerHTML = html.trim();
  const slot = wrapper.firstElementChild;
  if (!slot) return;
  list.appendChild(slot);
}

function removeCardSlot(card) {
  card.remove();
}

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const addBtn = target.closest(`[${ADD_ATTR}]`);
  if (addBtn instanceof HTMLElement) {
    const section = addBtn.closest('[data-associated-social-cards-mode="upload"]');
    if (!section) return;
    const list = section.querySelector(`[${LIST_ATTR}]`);
    const tpl  = section.querySelector(`#${TEMPLATE_ID}`);
    if (!(list instanceof HTMLElement) || !(tpl instanceof HTMLTemplateElement)) return;
    event.preventDefault();
    addCardSlot(list, tpl);
    return;
  }

  const removeBtn = target.closest(`[${REMOVE_ATTR}]`);
  if (removeBtn instanceof HTMLElement) {
    const card = removeBtn.closest('.associated-card');
    if (!card) return;
    const section = removeBtn.closest('[data-associated-social-cards-mode="upload"]');
    const confirmMessage = (section instanceof HTMLElement)
      ? (section.dataset.removeCardConfirmMessage || '')
      : '';
    if (confirmMessage !== '' && !confirm(confirmMessage)) return;
    event.preventDefault();
    removeCardSlot(card);
  }
});
